import { Injectable } from '@angular/core';
import { HorizontalListData, HorizontalListFactory, SignatureMethod, SignatureMethodLabel } from 'common';
import { ApplicationEnvelopeData, EnvelopeStatus, EnvelopeStatusLabel } from './signing-widget.model';

@Injectable()
export class SigningWidgetAdapter {
  // Read-only facts first, then every action in one link-plus-icon style. No per-document progress: DocuSign reports none.
  adaptListData = (signatureMethod: SignatureMethod, envelope: ApplicationEnvelopeData, canSwitch: boolean, canReadSignedAgreement: boolean): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Signature method',
        // An application can reach Pending Signature without intake, so the card also renders unpinned.
        displayedValue: SignatureMethodLabel.get(signatureMethod) ?? 'Not set',
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Envelope status',
        displayedValue: this.formatEnvelopeStatus(envelope),
        isItemHidden: !envelope,
      }),
      HorizontalListFactory.createCustomTemplateItem({
        customTemplateName: 'switchSignatureMethodActionItem',
        isItemHidden: !canSwitch,
      }),
      HorizontalListFactory.createCustomTemplateItem({
        customTemplateName: 'signedAgreementActionItem',
        isItemHidden: !(envelope?.executedDocumentId ?? envelope?.executedEntityDocumentId) || !canReadSignedAgreement,
      }),
      HorizontalListFactory.createCustomTemplateItem({
        customTemplateName: 'certificateActionItem',
        isItemHidden: !envelope?.certificateRetrievedOnUtc,
      }),
      HorizontalListFactory.createCustomTemplateItem({
        customTemplateName: 'docuSignEnvelopeActionItem',
        isItemHidden: !envelope?.docuSignEnvelopeUrl,
      }),
    ];
  }

  private formatEnvelopeStatus(envelope: ApplicationEnvelopeData): string {
    if (!envelope)
      return null;

    const label = EnvelopeStatusLabel.get(envelope.status) ?? envelope.status;
    return envelope.status === EnvelopeStatus.Voided && envelope.voidedReason
      ? `${label}: ${envelope.voidedReason}`
      : label;
  }
}
